import { render, staticRenderFns } from "./WeekAlldayItemDb.vue?vue&type=template&id=cfcc7e9c"
import script from "./WeekAlldayItemDb.ts?vue&type=script&lang=ts&external"
export * from "./WeekAlldayItemDb.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports